import React from 'react';
import { ctaLink } from '../data/mock';
import { Zap, Target, TrendingUp, Rocket } from 'lucide-react';

const InvitationSection = () => {
  const handleCTAClick = () => {
    if (window.fbq) {
      window.fbq('track', 'Subscribe');
    }
  };

  const joinReasons = [
    { icon: Zap, text: "Dah penat trial and error sorang-sorang" },
    { icon: Target, text: "Nak tools yang actually useful, bukan fancy je" },
    { icon: TrendingUp, text: "Faham yang trading adalah marathon, bukan sprint" },
    { icon: Rocket, text: "Ready nak improve, bukan nak shortcut" }
  ];

  return (
    <section className="bg-[#F8F8F8] py-[50px] px-[25px] md:py-[75px] md:px-[75px] lg:py-[100px] lg:px-[100px]">
      <div className="max-w-4xl mx-auto">
        {/* Main Headline */}
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-[#191919] text-center mb-8 tracking-tight leading-tight">
          Fira Tak Nak <span className="text-[#FF6699]">Paksa</span> Anda Join.
        </h2>

        {/* Reason */}
        <p className="text-xl md:text-2xl text-[#191919]/70 text-center font-medium mb-16">
          Sebab trader yang join sebab kena paksa — akan quit bila first loss.
        </p>

        {/* Who Should Join */}
        <div className="text-center mb-12">
          <p className="text-2xl md:text-3xl text-[#191919] font-bold mb-8">
            I nak trader yang join sebab:
          </p>

          {/* Join Reasons List - All in One Border */}
          <div className="border-2 border-[#191919]/10 rounded-3xl p-6 md:p-10 max-w-2xl mx-auto hover:border-[#FF6699]/30 transition-all duration-300">
            <div className="space-y-6">
              {joinReasons.map((reason, index) => {
                const IconComponent = reason.icon;
                return (
                  <div 
                    key={index}
                    className="flex items-center gap-4 text-left"
                  >
                    <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#FF6699]/10 flex items-center justify-center flex-shrink-0">
                      <IconComponent className="w-5 h-5 md:w-6 md:h-6 text-[#FF6699]" />
                    </div>
                    <p className="text-lg md:text-xl text-[#191919] font-medium">
                      {reason.text}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="text-center space-y-6 pt-8">
          {/* Big Pink Text - No Fill */}
          <p className="text-4xl md:text-5xl lg:text-6xl text-[#FF6699] font-black">
            Kalau tu anda — jom.
          </p>
          
          <p className="text-xl md:text-2xl text-[#191919]/60 font-medium">
            Kalau bukan — takpe. Semoga jumpa apa yang anda cari.
          </p>

          {/* CTA Button */}
          <div className="pt-8">
            <a
              href={ctaLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleCTAClick}
              className="inline-block bg-[#33CCCC] hover:bg-[#2ab8b8] text-[#191919] font-bold text-lg md:text-xl px-10 py-4 rounded-full transition-all duration-300 transform hover:scale-105"
            >
              Claim Access Percuma
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvitationSection;
